
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.18 15.68L7.5 9.43H5.82V4.82L2.5 11.07h1.68v4.61zM8.047 2.32c.312 0 .573.118.781.352.235.208.352.469.352.781v12.774c0 .312-.117.572-.352.78a1.06 1.06 0 01-.781.313H1.953c-.312 0-.586-.104-.82-.312a1.06 1.06 0 01-.313-.781V3.453c0-.312.104-.573.313-.781.234-.235.508-.352.82-.352H3.32V.68h3.36v1.64h1.367z","fill":"currentColor"}})])
          )
        }
      }
    